__turbopack_context__.v({
  "notificationsButton": "G4jHjW_notificationsButton",
  "notificationsButtonMedium": "G4jHjW_notificationsButtonMedium",
  "notificationsButton__count": "G4jHjW_notificationsButton__count",
});
